<template>
  <div class="pillList">
    <template v-for="pill in pills" :key="`${pill.type}-${pill.id}`">
      <ReachoutPill v-if="isReachoutPill(pill)" :reachout="pill.data" />
      <button
        v-else
        type="button"
        class="n-pill"
        @click.stop="openActivityDialog(pill)"
      >
        <FavIcon
          v-if="pill.type !== 'signal' && pill.data?.icon_type === 'favicon' && pill.data?.icon_name"
          :domain="pill.data.icon_name"
          :size="12"
        />
        <AppIcon
          v-else
          :name="activityPillPresentation(pill).icon"
          :size="12"
          :color="activityPillPresentation(pill).color"
        />
        {{ pillDisplayName(pill) }}
      </button>
    </template>
  </div>
</template>

<script setup lang="ts">
import AppIcon from '../../components/AppIcon.vue'
import FavIcon from '../../components/FavIcon.vue'
import ReachoutPill from './ReachoutPill.vue'
import {
  activityPillPresentation,
  type ActivityPill,
} from '../utils/candidates'
import { useActivityDialog } from '../composables/useActivityDialog'
import type { ReachoutPillData } from './ReachoutPill.vue'

const props = defineProps<{
  pills: ActivityPill[]
  onUpdated?: () => void
}>()

const { openActivityDialog } = useActivityDialog({ onUpdated: () => props.onUpdated?.() })

function isReachoutPill(pill: ActivityPill): pill is ActivityPill & { data: ReachoutPillData } {
  return typeof pill.type === 'string' && pill.type.startsWith('reachout_') && !!pill.data
}

function pillDisplayName(pill: ActivityPill): string {
  return (pill as any).first_name || pill.data?.first_name || activityPillPresentation(pill).kind
}
</script>

<style scoped>
.pillList {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}
</style>
